/**
 * @enum {string}
 * @description Enum for colors intended for use in the `color` attribute.
 */
export enum ColorEnum {
  light_green = "#98d5cc",
  green = "#4fa799",
  dark_green = "#1a6a7c",
  red = "red",
}

/**
 * @enum {string}
 * @description Enum for background styles.
 */
export enum BackgroundEnum {
  none = "none",
  dust = "url(/img/dust_scratches.png)",
  white = "white",
  grey = "#f6f6f6",
  transparent = "transparent",
}
